<template>
  <div class="pb-6">
    <div class="mb-4">
      <template v-if="userIsProjectAdmin">
        <v-text-field v-model="risks.title" variant="plain" density="compact" hide-details
                      class="font-weight-bold" style="--v-input-padding-top: 0" @change="saveRisks">
        </v-text-field>
        <v-textarea v-model="risks.description" variant="plain" density="compact" hide-details rows="1" auto-grow class="mt-n1"
                    @blur="saveRisks">
        </v-textarea>
      </template>
      <template v-else>
        <div class="font-weight-bold">{{ risks.title }}</div>
        <div class="mt-1 pre">{{ risks.description }}</div>
      </template>
    </div>

    <v-row>
      <v-col v-for="cell in risks.cells" :key="cell.id" cols="12" md="6" class="d-flex flex-column">
        <div class="d-flex align-center" style="min-height: 40px">
          <v-text-field v-if="userIsProjectAdmin" v-model="cell.title" variant="plain" density="compact" hide-details
                        class="font-weight-bold" style="--v-input-padding-top: 0" @change="saveRisks">
          </v-text-field>
          <div v-else class="font-weight-bold">{{ cell.title }}</div>
          <template v-if="userIsProjectAdmin">
            <v-btn-icon size="small" class="ml-auto export-hidden" @click="addItem(cell)">
              <v-icon>far fa-plus</v-icon>
            </v-btn-icon>
          </template>
        </div>
        <v-card class="pa-6 flex-grow-1">
          <div v-if="cell.items.length" class="d-flex flex-column gap-2">
            <template v-for="(item, itemIndex) in cell.items" :key="itemIndex">
              <div v-if="userIsProjectAdmin" class="d-flex align-start gap-2">
                <v-textarea v-model="item.text" :placeholder="$t('PROJECT_SHEET.RISKS.ITEM_PLACEHOLDER')"
                            variant="outlined" density="compact" rows="2" auto-grow hide-details @blur="saveRisks">
                </v-textarea>
                <v-btn-icon size="x-small" color="darkgrey" @click="removeItem(cell, itemIndex)">
                  <v-icon>far fa-trash</v-icon>
                </v-btn-icon>
              </div>
              <template v-else>
                <div class="pre">{{ item.text }}</div>
                <hr class="ma-0" v-if="itemIndex != cell.items.length - 1" style="opacity: .6">
              </template>
            </template>
          </div>
          <div v-else class="text-center text-medium-emphasis h-100 align-content-center">
            {{ $t('PROJECT_SHEET.RISKS.EMPTY_CELL') }}
            <div v-if="userIsProjectAdmin">
              <v-btn size="small" rounded variant="outlined" class="mt-2" @click="addItem(cell)">
                <v-icon start>far fa-plus</v-icon>{{ $t('GLOBAL.ADD') }}
              </v-btn>
            </div>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  export default {
    props: {
      planning: { type: Object, required: true },
    },
    emits: ['update'],
    data() {
      const defaultCells = [
        { id: 'strengths', title: this.$t('PROJECT_SHEET.RISKS.SWOT.STRENGTHS'), items: [] },
        { id: 'weaknesses', title: this.$t('PROJECT_SHEET.RISKS.SWOT.WEAKNESSES'), items: [] },
        { id: 'opportunities', title: this.$t('PROJECT_SHEET.RISKS.SWOT.OPPORTUNITIES'), items: [] },
        { id: 'threats', title: this.$t('PROJECT_SHEET.RISKS.SWOT.THREATS'), items: [] },
      ];
      const risks = this.planning.projectsheet?.risks || {};

      return {
        risks: {
          title: risks.title || this.$t('PROJECT_SHEET.RISKS.TITLE'),
          description: risks.description || this.$t('PROJECT_SHEET.RISKS.DESCRIPTION'),
          cells: risks.cells?.length ? risks.cells.map(cell => ({ id: window.uuid(), title: '', items: [], ...cell })) : defaultCells,
        },
        userIsProjectAdmin: this.planning.meta.access_right == 'admin',
      };
    },
    methods: {
      addItem(cell) {
        cell.items.push({ text: '' });
        this.saveRisks();
      },
      removeItem(cell, itemIndex) {
        cell.items.splice(itemIndex, 1);
        this.saveRisks();
      },
      saveRisks() {
        this.$emit('update', {
          risks: this.risks,
        });
      },
    },
  };
</script>
